const variantRadioComponent = document.querySelector('variant-radios');

// Check if the component exists
if (!variantRadioComponent) {
  console.warn("variantRadioComponent not found on the page.");
} else {
  variantRadioComponent.addEventListener('materialChange', function (event) {
    console.log("Event listener triggered");
    const materialValue = event.detail.material;
    changeAllUpsellMaterials(materialValue);
  });
}

function changeAllUpsellMaterials(material) {
  const sizeSpan = document.querySelector('[data-header-option]');
  if (!sizeSpan) {
    console.warn("No size span found with [data-header-option]");
    return;
  }

  const selectedSize = sizeSpan.textContent.trim();
  if (!selectedSize) {
    console.warn("No valid size found in the size span.");
    return;
  }

  console.log(`Selected size: "${selectedSize}"`);

  const upsellProducts = document.querySelectorAll('.upsell-product');
  if (upsellProducts.length === 0) {
    console.warn("No upsell products found.");
    return;
  }

  upsellProducts.forEach(upsell => {
    const compatibleSizes = upsell.dataset.compatibleSizes?.split(',').map(size => size.trim()) || [];
    console.log(`Checking upsell product:`, upsell);

    if (compatibleSizes.includes(selectedSize)) {
      console.log(`Match: Selected size "${selectedSize}" matches compatible sizes: ${compatibleSizes.join(', ')}`);
    } else {
      console.log(`Does not match: Selected size "${selectedSize}" does not match compatible sizes: ${compatibleSizes.join(', ')}`);
    }
  });
}
